import { useQuery } from '@tanstack/react-query';
import { fetchCompetitions } from '../api/client';
import { MOCK_COMPETITIONS } from '../builder/widgetTypes';

export function useCompetitions() {
  return useQuery({
    queryKey: ['competitions'],
    queryFn: async () => {
      const { competitions } = await fetchCompetitions();
      return competitions;
    },
    staleTime: 3600_000,
    placeholderData: MOCK_COMPETITIONS,
  });
}
